import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Consumes extra URL segments under a custom-element mount (e.g. `/customElements/st/sub`)
 * so the host router still matches the parent {@link CustomElementHostPageComponent} route.
 * The embedded plugin controls real UI; this outlet stays empty.
 */
@Component({
  selector: 'app-custom-element-host-child-placeholder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: '',
})
export class CustomElementHostChildPlaceholderComponent {}
